import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { getCurrentCanvasSize } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import { DefaultDesigner } from '../Components/DesignerUI';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import {
  getClientHighlightColor,
  visualizationModeCheck,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { isFallbackVisualizationMode } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { designAreaAppliesMask } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/MaskSelectors';
import { getActiveHintMessage } from '../Reducers/HintMessages/Selectors';

const mapStateToProps = (state) => {
  const canvasSize = getCurrentCanvasSize(state);
  const show = canvasSize.width > 0 && canvasSize.height > 0;
  const selectedColor = getClientHighlightColor(state);
  const enableHiding = visualizationModeCheck(state).is3D();
  const hasBorder = !designAreaAppliesMask(state);
  const activeHintMessage = getActiveHintMessage(state);
  return {
    Component: DefaultDesigner,
    canvasSize,
    show,
    selectedColor,
    hasBorder,
    hideDesigner: enableHiding ? Services.designData.closeDesignAreaEditor : undefined,
    useCheckerBoardBackground: isFallbackVisualizationMode(state),
    activeHintMessage,
  };
};

export default containerConnect(mapStateToProps);
